// src/pages/Belege.js

import React, { useState } from 'react';
import {
  Box,
  Typography,
  useMediaQuery,
  TextField,
  Grid
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import BelegUploadProfessional from '../components/BelegUploadProfessional';
import DocumentManagement from '../components/DocumentManagement';

const Belege = ({ showFilters }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const [searchTerm, setSearchTerm] = useState('');
  const [dateFrom, setDateFrom] = useState('');
  const [dateTo, setDateTo] = useState('');

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
    // Optional: Übergib das Suchfeld an DocumentManagement
  };

  return (
    <Box p={isMobile ? 1 : 3}>
      <Typography variant="h4" gutterBottom>
        Belege
      </Typography>
      <Typography variant="body1" gutterBottom>
        Willkommen auf der Belegeseite!
      </Typography>

      {showFilters && (
        <Box my={3}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={4}>
              <TextField
                fullWidth
                label="Suche nach Stichwort"
                variant="outlined"
                value={searchTerm}
                onChange={handleSearchChange}
              />
            </Grid>
            <Grid item xs={6} md={4}>
              <TextField
                fullWidth
                type="date"
                label="Von"
                InputLabelProps={{ shrink: true }}
                value={dateFrom}
                onChange={(e) => setDateFrom(e.target.value)}
              />
            </Grid>
            <Grid item xs={6} md={4}>
              <TextField
                fullWidth
                type="date"
                label="Bis"
                InputLabelProps={{ shrink: true }}
                value={dateTo}
                onChange={(e) => setDateTo(e.target.value)}
              />
            </Grid>
          </Grid>
        </Box>
      )}

      <Box my={4}>
        <BelegUploadProfessional />
      </Box>

      <Box my={4}>
        <Typography variant="h6" gutterBottom>
          Ihre hochgeladenen Dokumente
        </Typography>
        <DocumentManagement
          search={searchTerm}
          dateFrom={dateFrom}
          dateTo={dateTo}
        />
      </Box>
    </Box>
  );
};

export default Belege;
